module.exports = __webpack_public_path__ + "static/media/fitnessTrackerS.98ce958d.png";